import { useState } from "react";
import { Link } from "react-router-dom";
import { loginUser } from "../services/auth";
import LoginExtraLinks from "../components/LoginExtraLinks";
import "../styles/loginExtraLinks.css";
import "../styles/auth.css";

export default function Login() {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    async function handleLogin(e) {

        e.preventDefault();

        try {

            const res = await loginUser({

                email,
                password

            });

           localStorage.setItem("token", res.data.token);

localStorage.setItem("userName", res.data.user.full_name);

localStorage.setItem("userEmail", res.data.user.email);

localStorage.setItem("userId", res.data.user.id);

window.location = "/";

        }

        catch (err) {

            alert(err.response?.data?.message || "Login failed");

        }

    }

    return (

        <div className="authContainer">

            <div className="authCard">

                <h1>CercaTrova</h1>

                <p>Solar Monitoring Platform</p>

                <form onSubmit={handleLogin}>

                    <input
                        type="text"
                        placeholder="Email/Phone"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />

                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />

                    <Link to="/forgot-password" className="forgotLink">
                        Forgot password?
                    </Link>

                    <button type="submit">

                        Login

                    </button>

                </form>

                <p>

                    Don't have an account?

                    <Link to="/register">

                        Register

                    </Link>

                </p>
<LoginExtraLinks />
            </div>
            
        </div>

    );

}